module.exports = __webpack_public_path__ + "img/compass.a3e0d88e.svg";